/* eslint-disable no-magic-numbers */

const dev =  window.location.origin.indexOf('indiviormedicalaffairs') === -1;

const domain = dev ? atob('aHR0cHM6Ly95Yjk0czhieXBrLmV4ZWN1dGUtYXBpLnVzLWVhc3QtMS5hbWF6b25hd3MuY29tL2Rldg==') : '';

const dropdownEndpoint = domain + '/api/dropdown/list';
const congressEndpoint = domain + '/api/congress/list';
const publicaitonEndpoint = domain + '/api/publication/list';
const otherPublicationEndpoint = domain + '/api/other-publication/list';

export {
    dropdownEndpoint,
    congressEndpoint,
    publicaitonEndpoint,
    otherPublicationEndpoint
};
